module.exports = __webpack_public_path__ + "static/media/excel.5b89b242.svg";